import { Game } from '../Components/Lobby/Home/GameSection';

// Thumbnails
import predictThumbnail from '/images/lobby/games/predict.png';
import crashxThumbnail from '/images/lobby/games/crashx.png';
import hiloThumbnail from '/images/lobby/games/hilo.png';
import pandaBaoThumbnail from '/images/lobby/games/panda-bao.png';
import tapinataThumbnail from '/images/lobby/games/tapinata.png';
import chickenRoadThumbnail from '/images/lobby/games/chicken-road.png';
import turboPlinkoThumbnail from '/images/lobby/games/turbo-plinko.png';
import ripCityThumbnail from '/images/lobby/games/rip-city.png';
import wantedDeadOrAWildThumbnail from '/images/lobby/games/wanted-dead-or-a-wild.png';
import chaosCrewTwoThumbnail from '/images/lobby/games/chaos-crew-2.png';
import dorkUnitThumbnail from '/images/lobby/games/dork-unit.png';
import stormforgedThumbnail from '/images/lobby/games/stormforged.png';
import cursedSeasThumbnail from '/images/lobby/games/cursed-seas.png';
import magicPiggyThumbnail from '/images/lobby/games/magic-piggy.png';

// Provider Icons
import hacksawIcon from '/images/lobby/games/hacksaw.svg';
import pokerSolutionsIcon from '/images/icon.svg';
import turbogamesIcon from '/images/lobby/games/turbogames.svg';
import inOutIcon from '/images/lobby/games/inout.svg';

export const highstakesGames: Game[] = [
  {
    thumbnail: predictThumbnail,
    title: 'PREDICT',
    link: '/prediction',
    providerIcon: pokerSolutionsIcon,
    providerName: 'POKERSOLUTIONS'
  },
  {
    thumbnail: turboPlinkoThumbnail,
    title: 'TURBO PLINKO',
    link: '/games/turboplinko',
    providerIcon: turbogamesIcon,
    providerName: 'TURBO GAMES'
  },
  {
    thumbnail: chickenRoadThumbnail,
    title: 'CHICKEN ROAD',
    link: '/casino/play/chicken-road-2-0',
    providerIcon: inOutIcon,
    providerName: 'INOUT'
  },
  {
    thumbnail: crashxThumbnail,
    title: 'CRASHX',
    link: '/games/crash',
    providerIcon: turbogamesIcon,
    providerName: 'TURBO GAMES'
  },
  {
    thumbnail: hiloThumbnail,
    title: 'HILO',
    link: '/games/hilo',
    providerIcon: turbogamesIcon,
    providerName: 'TURBO GAMES'
  },
  {
    thumbnail: pandaBaoThumbnail,
    title: 'PANDA BAO',
    link: '/games/pandabao',
    providerIcon: turbogamesIcon,
    providerName: 'TURBO GAMES'
  },
  {
    thumbnail: tapinataThumbnail,
    title: 'TAPINATA',
    link: '/games/tapinata',
    providerIcon: turbogamesIcon,
    providerName: 'TURBO GAMES'
  },
];

export const hacksawGames: Game[] = [
  {
    thumbnail: ripCityThumbnail,
    title: 'RIP CITY',
    link: '/casino/play/rip-city',
    providerIcon: hacksawIcon,
    providerName: 'HACKSAW'
  },
  {
    thumbnail: wantedDeadOrAWildThumbnail,
    title: 'WANTED DEAD OR A WILD',
    link: '/casino/play/wanted-dead-or-a-wild-88',
    providerIcon: hacksawIcon,
    providerName: 'HACKSAW'
  },
  {
    thumbnail: chaosCrewTwoThumbnail,
    title: 'CHAOS CREW II',
    link: '/casino/play/chaos-crew-ii',
    providerIcon: hacksawIcon,
    providerName: 'HACKSAW'
  },
  {
    thumbnail: dorkUnitThumbnail,
    title: 'DORK UNIT',
    link: '/casino/play/dork-unit-96',
    providerIcon: hacksawIcon,
    providerName: 'HACKSAW'
  },
  {
    thumbnail: stormforgedThumbnail,
    title: 'STORMFORGED',
    link: '/casino/play/stormforged',
    providerIcon: hacksawIcon,
    providerName: 'HACKSAW'
  },
  {
    thumbnail: cursedSeasThumbnail,
    title: 'CURSED SEAS',
    link: '/casino/play/cursed-seas',
    providerIcon: hacksawIcon,
    providerName: 'HACKSAW'
  },
  {
    thumbnail: magicPiggyThumbnail,
    title: 'MAGIC PIGGY',
    link: '/casino/play/magic-piggy',
    providerIcon: hacksawIcon,
    providerName: 'HACKSAW'
  },
];
